import React from "react";
import ReactDOMServer from "react-dom/server";
import Widget from "../preview"

export function jsonToHtml(json) {
  return ReactDOMServer.renderToStaticMarkup(
    <Widget data={json} device={"desktop"} mode={"live"} />
  );
}